import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environment/environment';

@Pipe({
  standalone: true,
    name: 'img',
})
export class ImgPipe implements PipeTransform {
    browserType = '';
    imageTail = 'webp';
    transform(images: any[], state?: string, size?: string): string {

        // if (environment.production) {
        try {
            const ua = navigator.userAgent.toLowerCase();
            // safari images
            if ( ((ua.indexOf('macintosh') != -1) || (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1)) ){
                const imageObject = !size ?
                    (images.find((i: any) => i.size === 'md') &&
                        images.find((i: any) => i.Key.endsWith('.jpg'))) :
                    (images.find((i: any) => i.size === size) && images.find((i: any) => i.Key.endsWith('.jpg')));
                if (!imageObject) {
                    var fallbackImage = (images.find((i: any) => i.size === 'md'));
                    return `${fallbackImage.Key}`;

                } else {
                    return `${imageObject.Key}`;
                }
            // non safari images
            } else {
                const imageObject = !size ?
                    (images.find((i: any) => i.size === 'md') &&
                        images.find((i: any) => i.Key.endsWith('.webp'))) :
                    (images.find((i: any) => i.size === size) && images.find((i: any) => i.Key.endsWith('.webp')));
                if (!imageObject) {
                    var fallbackImage = (images.find((i: any) => i.size === 'md'));
                    return `${fallbackImage.Key}`;
                } else {
                    return `${imageObject.Key}`;
                }
            }

        } catch (e) {
            if (!state || state === undefined || state === null) {
                return `/img/destination/fallback.${this.imageTail}`;
            } else {
                const imgState = state.trim().toLowerCase();
                if (imgState.includes(' ')) {
                    const splitState = imgState.split(' ');
                    const joinedState = splitState.join('-');
                    return `/img/destination/${joinedState}.${this.imageTail}`;
                } else {
                    return `/img/destination/${imgState}.${this.imageTail}`;
                }
            }
        }
    }
}